var isType = require('./isType');

module.exports = function isMaybe(x) {
  return isType(x) && ( x.meta.kind === 'maybe' );
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/tcomb/lib/isMaybe.js
// module id = 627
// module chunks = 0